import type { ReactElement } from 'react';

import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import DropdownBottomSheet from '@shared/ui/common/DropdownBottomSheet';
import DropdownPopover from '@shared/ui/common/DropdownPopover';

type Props = {
  id: string;
  title: string;
  displayText: string;
  selected?: boolean;
  disabled?: boolean;
  children: ReactElement;
};

const DropdownSelector = ({
  children,
  disabled,
  displayText,
  id,
  selected,
  title,
}: Props) => (
  <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
    {(isMobile: boolean) =>
      isMobile ? (
        <DropdownBottomSheet
          id={id}
          displayText={displayText}
          title={title}
          selected={selected}
          disabled={disabled}
        >
          {children}
        </DropdownBottomSheet>
      ) : (
        <DropdownPopover
          id={id}
          displayText={displayText}
          label={title}
          selected={selected}
          disabled={disabled}
        >
          {children}
        </DropdownPopover>
      )
    }
  </BpkBreakpoint>
);

export default DropdownSelector;
